import { useNavigate } from 'react-router-dom';
import { Warning, Trophy } from '@phosphor-icons/react';

const WORLD_CUP_TROPHY = "https://images.unsplash.com/photo-1637203727700-9d86c74904d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHx3b3JsZCUyMGN1cCUyMHRyb3BoeSUyMGdvbGR8ZW58MHx8fHwxNzc1NzI2NDYzfDA&ixlib=rb-4.1.0&q=85&w=200";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: 'var(--bg-main)' }}>
      <div className="text-center max-w-md">
        <img 
          src={WORLD_CUP_TROPHY} 
          alt="World Cup" 
          className="w-24 h-24 object-cover rounded-full mx-auto mb-6 opacity-50"
        />
        <h1 className="text-4xl mb-4" style={{ fontFamily: 'Barlow Condensed, sans-serif' }} data-testid="not-found-title">
          Page Not Found
        </h1>
        <p className="text-gray-600 mb-8">
          This World Cup Predictor page doesn't exist. 
          If you're looking for a specific club, check the link you were given.
        </p>
        <p className="text-sm text-gray-400">
          Club admin? Go to <code className="bg-gray-100 px-2 py-1 rounded text-gray-600">/worldcup2026/your-club/admin</code>
        </p>
      </div>
    </div>
  );
}
